export default "__VITE_ASSET__39204391__"